import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import DocumentPage from "../pages/Document";
import ListEmailsPage from "../pages/ListEmails";
import { LoginForm } from "../pages/LoginForm";
import { PasswordCode } from "../pages/PasswordCode";
import PasswordCreate from "../pages/PasswordCreate";
import PasswordForgot from "../pages/PasswordForgot";
import Register from "../pages/Register";
import RegisterAddress from "../pages/RegisterAddress";
import CartTracking from "../pages/CartTracking"; // Import the new component

function Routes() {
  return (
    <Router basename="/">
      <Switch>
        <Route path="/login" exact component={DocumentPage} />
        <Route path="/login/emails" exact component={ListEmailsPage} />
        <Route path="/login/form" exact component={LoginForm} />
        <Route path="/password/code" exact component={PasswordCode} />
        <Route path="/password/create" exact component={PasswordCreate} />
        <Route path="/password/reset" exact component={(props) => <PasswordCreate {...props} withResetModal />} />
        <Route path="/password/forgot" exact component={PasswordForgot} />
        <Route path="/register" exact component={Register} />
        <Route path="/register/address" exact component={RegisterAddress} />
        <Route path="/cart-tracking" exact component={CartTracking} /> {/* Adicionada rota para rastreamento de carrinho */}
        <Redirect exact path="/password" to="/login/form" />
        <Redirect path="/" to="/login" />
      </Switch>
    </Router>
  )
}

export default Routes;